<template>
  <div class="m_home">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
          v-model:loading="loading"
          :finished="finished"
          :finished-text="finishedText"
          ref = "vanList"
          :immediate-check = "false"
          @load="onLoad"
      >
        <div class="card_box">
          <router-link
              v-for="video in videoList"
              :key="video.id"
              :title="video.Title"
              :to="{ name: 'VideoPlay', query: { pid: video.ID } }"
              class="v_card"
          >
            <div class="card">
              <div class="img_wrap">
                <div class="bfs_img">
                  <picture class="img_inner">
                    <img class="img"
                         src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=="
                         :alt="video.Title"
                         v-lazy="video.Cover"
                         @error="handleImageError"
                    >
                  </picture>
                </div>
              </div>
              <div class="count">
                <span>
                  <i class="iconfont icon_shipin_bofangshu"></i>
                  {{ getViews(video.Views) }} <!-- 播放量 -->
                </span>
                <span>
                  <i class="iconfont icon_shipin_danmushu"></i>
                  {{ video.comments }} <!-- 弹幕数 -->
                </span>
              </div>
            </div>
            <p class="title">{{ video.Title }}</p>
          </router-link>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      videoList: [],
      offset : 0,
      limit:20,
      finishedText : '没有更多了',
      index:1,
      cachedOnce:false,
      hashName:"#gc",
      slug:"hrcm",
    };
  },
  methods: {
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.offset = 0;
      this.onLoad();
    },
    onLoad() {
      setTimeout(() => {
        if (this.refreshing) {
          this.videoList = [];
          this.refreshing = false;
        }
        this.getList();
        this.offset += this.limit;
      }, 50);
    },
    async getList() {
      try {
        const res = await this.$v_http.get(`/getList?category=${this.slug}&limit=${this.limit}&offset=${this.offset}`);
        if (res.data?.code==-500) {
          console.error("获取视频列表失败：");
          this.finishedText ="服务器错误！联系管理员"
          this.loading = false;
          this.finished = true;
          return
        }
        if (res.data?.code==-404) {
          console.error("获取视频列表失败：");
          this.loading = false;
          this.finished = true;
          return
        }
        if (res.data?.data?.Videos) {
          const videos = res.data.data.Videos;
          this.videoList = this.offset === 0 ? videos : [...this.videoList, ...videos];
          if (videos.length < 20) this.finished = true;
          sessionStorage.setItem(`${this.slug}_videoList`, JSON.stringify(this.videoList));
          sessionStorage.setItem(`${this.slug}_finished`, JSON.stringify(this.finished));
          sessionStorage.setItem(`${this.slug}_offset`, JSON.stringify(this.offset));
        }
        this.loading = false;
      } catch (error) {
        console.error("获取视频列表失败：", error);
        this.loading = false;
        this.finished = true;
      }
    },
    handleImageError(event) {
      const img = event.target;
      const randomInteger = Math.floor(Math.random() * 401) + 1;
      img.src = require("@/assets/madou/"+randomInteger + '.jpg'); // 使用正确的图片路径
    },
    getViews(views){
      switch (views) {
        case 0 :
          return "-"
        case views<1000:
          return views
        default:
          return `${(views/10000).toFixed(1)}万`
      }
    }
  },
  mounted() {
    // 页面首次加载时监听滚动
    const cachedData = sessionStorage.getItem(`${this.slug}_videoList`);
    if (cachedData) {
      this.videoList = JSON.parse(cachedData);
      this.finished = JSON.parse(sessionStorage.getItem(`${this.slug}_finished`));
      this.offset = JSON.parse(sessionStorage.getItem(`${this.slug}_offset`));
    } else {
      this.loading = true;
      this.onLoad();
    }
  },
  directives: {
    lazy: {
      mounted(el, binding) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              el.src = binding.value;
              observer.unobserve(el);
            }
          });
        });
        el.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
        observer.observe(el);
      },
    },
  },
  activated() {
    if (this.cachedOnce) {
      // 如果已经激活过，销毁当前实例
      this.$destroy();
    } else {
      this.cachedOnce = true;
    }
  },
  beforeUnmount() {
    const scrollTop = window.scrollY || window.pageYOffset; // 获取垂直滚动位置
    sessionStorage.setItem(this.hashName, scrollTop); // 保存到 sessionStorage
  }
};
</script>

<style scoped lang="scss">
.card_box {
  display: flex;
  flex-wrap: wrap;
  padding: 0 1.33333vmin;
}

.v_card {
  width: 50%;
  padding: 2.13333vmin 1.33333vmin;
  display: inline-block;
  box-sizing: border-box;

  .card {
    position: relative;
    background-color: #f3f3f3;
    border-radius: 0.53333vmin;
    overflow: hidden;
    .count {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      font-size: 3.2vmin;
      padding: 1.33333vmin 1.6vmin;
      display: flex;
      justify-content: space-between;
      color: #fff;
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.85), transparent);
      box-sizing: border-box;
      span {
        display: flex;
        gap: 1vw;
        align-items: center;
        justify-content: center;
      }
      .icon {
        height: 3.5vmin;
      }
    }
  }

  .title {
    font-size: 3.2vmin;
    color: #212121;
    margin-top: 1.6vmin;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .img_wrap {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
  }

  .bfs_img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: transparent;

    .img_inner {
      display: block;
      width: 100%;
      height: 100%;

      .img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
</style>
